module.exports = __webpack_public_path__ + "media/images/icon/icons8-Logout Rounded-ada75caa72c81ba80e43f7030356051b.png";